export class NewProjects {
    buyer_first_name: string;
    buyer_id: number;
    buyer_last_name: string;
    project_id: number;
    project_name: string;
    project_status: Number;
    description: string;
    is_waiting: boolean;
    lat: string;
    lon: string;
    is_inside_seller_service_area: boolean;
    is_gray_pin: boolean;
    is_selected_by_buyer: boolean;
    is_waiting_button_enabled: boolean;
    is_draft: boolean;
    drafted_project_agreements_as_dict: any;
}

export class ProjectDetails {
    agreement_file_path: string;
    details: string;
    estimated_cost: number;
    estimated_duration: number;
    estimated_started_date: string;
    lat: string;
    lon: string;
    overview: string;
    project_id: number;
    project_name: string;
    project_status: number;
    seller_account_id: number;
    seller_id: number;
    size: string;
    sketch: string;
    buyer_id: number;
    buyer_user_id: number;
    is_inside_seller_service_area: boolean;
    service_category: string;
    project_end_date: string;
    project_start_date: string;
    service_category_icon_url: string;
    project_street_name: string;
    project_zip_code: string;
    project_city: string;
    total_price: number;
    is_waiting: boolean;
   // overview: string;
}

export class Addworker {
    seller_id: number;
    project_id: number;
    worker_type: string;
    worker_name: string;
    worker_email: string;
    hourly_rate: string;
    phone_no: string;
    designation: string;
    contact_person_name: string;
    contact_person_phone_no: string;
    registration_url: string;
}

export class UpdateWorkerInformation {
    worker_id: number;
    worker_name: string;
    worker_type_id: string;
    hourly_rate: string;
    phone_no: string;
    designation: string;
    contact_person_name: string;
    contact_person_phone_no: string;
}

export class AgreementCreateObj {
    nameperson1: string;
    nameperson2: string;
    identitynumberperson1: string;
    identitynumberperson2: string;
    firstStepemail: string;
    firstStepPhonenumber1: number;
    firstStepAddress: string;
    sellername: string;
    sellerorganization: string;
    selleremail: string;
    sellerphonenumber: number;
    sellerAddress: string;
    sellerregistredforTax: string;
    sellerregistredNumber: string;
    sellercompanyinsurance: string;
    buyeraddressservicetakeplace: string;
    buyerworkdescription: string;
    buyerworkspecification: string;
    buyerworkExecuted: string;
    buyerworknotrecommended: string;
    priceOption1: string;
    priceOption2: string;
    priceOption3: string;
    isTotalFastPrice: boolean;
    fastpriceTotal: number;
    fastpriceArbete: number;
    fastpriceMaterial: number;
    fastpriceResor: number;

    ungefarligprisuppgift: number;
    lopandeArbete: number;
    lopandeArbetsledning: number;
    lopandeOverenskomna: number;
    lopandeMaterial: number;
    lopandeResorDetails: string;


    taxdeduction: string;
    propertyId: string;
    propertyorgno: string;
    individualtaxdeduction: string;
    startdate: Date;
    enddate: Date;
    hourlyPriceadditionalwork: number;
    hourlyPriceadditionalworkManage: number;
    paymentOption1: boolean;
    paymentOption2: boolean;
    paymentOption3: boolean;
    paymentOption4: boolean;
    additionalTerms: boolean;

    Beskrivning: string;
    Ritning: string;
    ovigt: string;

    filevailableBeskrivning: string;
    filevailableRitning: string;
    filevailableovigt: string;

    additionalagreement: string;
    uploaded_links: Array<any> = [];
    offerExpirydate: Date;
    total_price: number;
    yosso_fee: number;

}

export class AgreementData {
    html_content: string;
    project_id: number;
    seller_id: number;
    buyer_id: number;
    project_start_date: Date;
    project_end_date: Date;
    offer_expiry_date: Date;
    is_fixed_price: boolean;
    is_approximate_price: boolean;
    is_ongoing_bill: boolean;
    total_price: number;
    yosso_fee: number;
    work_cost: number;
    material_cost: number;
    travel_cost: number;
    approximate_cost: number;
    work_hourly_cost: number;
    work_flow_hourly_cost: number;
    sub_contract_cost_rate: number;
    other_cost_rate: number;
    risk_and_liability: string;
    uploaded_links: Array<any>;
    work_and_materials: string;
    work_if_craft_man_declined: string;
    reason_for_rejection: string;
    is_with_ROT_deduction: boolean;
    condominium_designation: string;
    association_org_no: string;
    ROT_deduction_client: string;
    hourly_rate_for_work: number;
    hourly_rate_for_work_management: number;
    is_additional_work_pay_on_invoice: boolean;
    is_entire_payment_done_after_work_done: boolean;
    is_payment_done_according_to_payment_plan: boolean;
    is_specified_invoice: boolean;
    other_agreements: string;
    is_from_create_offer: boolean;
    is_from_change_request: boolean;
    parent_agreement_id: number;
    travel_charge_details: string;
    is_fixed_price_direct_total: boolean;
    safety_box_link: string;
    status: number;
    is_draft: number;
}

export class ReportTimeWork {
    project_id: number;
    user_id: number;
    date: string;
    hours: string;
    comment: string;
    is_travel_cost_enabled: boolean;
    travel_distance: string;
    travel_type: string;
    reason: string;
}

export class UpdateReportTimeWork {
    project_id: number;
    user_id: number;
    date: string;
    hours: string;
    comment: string;
    is_travel_cost_enabled: boolean;
    travel_distance: number;
    travel_type: number;
    reason: string;
}

export class WorkerInformationObj {
    hourly_rate: string;
    seller_id: number;
    user_id: number;
    worker_id: number;
    worker_type_id: string;
    contact_person_name: string;
    contact_person_phone_no: string;
    worker_designation: string;
    worker_email: string;
    worker_name: string;
    worker_phone_no: string;
    worker_status_code: number;
    image_url: string;
    seller_user_id: number;

}

export class ChangeAgreementObject {
    nameperson1: string;
    nameperson2: string;
    identitynumberperson1: string;
    identitynumberperson2: string;
    firstStepemail: string;
    firstStepPhonenumber1: number;
    firstStepAddress: string;
    sellername: string;
    sellerorganization: string;
    selleremail: string;
    sellerphonenumber: number;
    sellerAddress: string;
    sellerregistredforTax: string;
    sellerregistredNumber: string;
    sellercompanyinsurance: string;

    agreement_name: string;
    extra_service_category_id: string;
    work_scope: string;
    is_credited: boolean;
    is_debited: boolean;
    debit_comment: string;

    priceOption1: string;
    priceOption2: string;
    priceOption3: string;
    isTotalFastPrice: boolean;
    fastpriceTotal: number;
    fastpriceArbete: number;
    fastpriceMaterial: number;
    fastpriceResor: number;

    ungefarligprisuppgift: number;
    lopandeArbete: number;
    lopandeArbetsledning: number;
    lopandeOverenskomna: number;
    lopandeMaterial: number;
    lopandeResorDetails: string;

    startdate: Date;
    enddate: Date;
    uploaded_links: Array<any> = [];
    offerExpirydate: Date;
    total_price: number;
    yosso_fee: number;

}



export class ChangeAgreementDbObject {

html_content: string;
project_agreement_id: number;
agreement_name: string;
extra_service_category_ids: Array<any>;
work_scope: string;
uploaded_links: Array<any>;
is_credited: boolean;
is_debited: boolean;
credit_comment: string;
project_start_date: Date;
project_end_date: Date;
new_project_end_date: Date;
liability_insurance: string;
is_fixed_price: boolean;
is_fixed_price_direct_total: boolean;
is_approximate_price: boolean;
is_ongoing_bill: boolean;
total_price: number;
yosso_fee: number;
work_cost: number;
material_cost: number;
travel_cost: number;
approximate_cost: number;
work_hourly_cost: number;
work_flow_hourly_cost: number;
sub_contract_cost_rate: number;
other_cost_rate: number;
travel_charge_details: string;
safety_box_link: string;
}



// WEBPACK FOOTER //
// ./src/app/seller/seller.ts